// Moneda de la plataforma: pesos dominicanos (DOP), enteros sin centavos.
// Único punto de verdad para formatear precios — si algún día cambia la
// moneda o el formato, se toca solo este archivo.
export const formatDOP = (value) =>
  `RD$${Math.round(Number(value) || 0).toLocaleString('es-DO')}`;
